import React from 'react';

import { ReactComponent as Logo } from '../../../../assets/images/logo.svg';

import * as S from './PageLoading.styles';

const PageLoading = () => (
  <S.Container>
    <Logo />
    <S.LoadingImg size={50} />
    <S.LoadingText>Carregando...</S.LoadingText>
  </S.Container>
);

export default PageLoading;
